import * as React from 'react';

import {StackLegacy} from 'shells/layout/stack/stack-legacy';

import {addNotification} from '../../../notifications/index';

import {useResetManagedMeetingChanges} from '../managed-meetings/graphql/hooks/use-reset-managed-meeting-changes';

import {useGetAssignments, useUpdateManagedMeetingTemplateAssignments} from './graphql/hooks';
import {TeamsTable} from './teams-table';
import {UsersTable} from './users-table';

type Props = {
    meetingId: string;
};

export function Assignment(props: Props) {
    const {meetingId} = props;

    const {userAssignments, teamAssignments, isLoading} = useGetAssignments(meetingId);
    const {updateManagedMeetingTemplateAssignments} = useUpdateManagedMeetingTemplateAssignments();
    const {resetManagedMeetingChanges} = useResetManagedMeetingChanges();

    return (
        <StackLegacy spacing={16}>
            <TeamsTable
                teamAssignments={teamAssignments}
                isLoading={isLoading}
                onAssignmentChange={(assignments) => {
                    updateManagedMeetingTemplateAssignments({
                        meetingId,
                        teams: assignments,
                    }).catch(() => {
                        addNotification('Assignment update failed', {
                            body: 'An unexpected error occurred. Please try again later.',
                            icon: 'frowny',
                        });
                    });
                }}
                onResetSeveredMeeting={(severedMeetingId) => {
                    resetManagedMeetingChanges({
                        severedMeetingId: severedMeetingId,
                    }).catch(() => {
                        addNotification('Resetting severed meeting failed', {
                            body: 'An unexpected error occured. Please try again later.',
                            icon: 'frowny',
                        });
                    });
                }}
            />
            <UsersTable
                userAssignments={userAssignments}
                isLoading={isLoading}
                onAssignmentChange={(assignments) => {
                    updateManagedMeetingTemplateAssignments({
                        meetingId,
                        users: assignments,
                    }).catch(() => {
                        addNotification('Assignment update failed', {
                            body: 'An unexpected error occurred. Please try again later.',
                            icon: 'frowny',
                        });
                    });
                }}
                onResetSeveredMeeting={(severedMeetingId) => {
                    resetManagedMeetingChanges({
                        severedMeetingId: severedMeetingId,
                    }).catch(() => {
                        addNotification('Resetting severed meeting failed', {
                            body: 'An unexpected error occured. Please try again later.',
                            icon: 'frowny',
                        });
                    });
                }}
            />
        </StackLegacy>
    );
}
